// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"30":"584751bb","78":"d42b26de","338":"07732aaf","371":"e48368e3","431":"1b259729","544":"3b5c0a91","557":"8ee9bd58","576":"11044292","727":"df4fc8fe","738":"89e1de7b","753":"e96c7cbc","775":"3c9c5188","823":"1e6ad294","961":"95c36269","990":"a9fec27e"}[chunkId] + ".js";
};